module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eJMSD"))).then(() => module.bundle.root('1iHdE'));